<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 flex-header text-center text-sm-left mb-0">
        <h3 class="page-title">Komornicy</h3>
        <d-button
          theme="success"
          @click="$router.push({name: 'bailiff-new'})">
          <i class="material-icons">add</i> Nowy komornik
        </d-button>
      </div>
    </div>

    <!-- Default Light Table -->
    <template v-if="loadError">
      <d-alert
        show
        theme="warning">
        Wczytywanie danych nie powiodło się.
        <a
            href="javascript:window.location.reload();"
            class="alert-link">
            Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
    </template>
    <template v-else>
      <transition name="fade">
        <d-card class="card-small">
          <div
            v-if="!loaded"
            class="overlay-loading">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
          </div>
          <d-card-header class="border-bottom flex-header">
            <div class="search-wrapper">
              <d-input-group>
                <d-select
                  type="text"
                  name="with-cases"
                  id="with-cases"
                  v-model="filters.with_cases">
                  <option value="">--Wszyscy</option>
                  <option value="1">Sprawy z otwartymi wnioskami</option>
                  <!-- <option value="2"></option>-->
                </d-select>
                <button
                  class="button btn autocomplete-clear btn-primary"
                  @click.prevent="filterList">
                  Szukaj
                </button>
                <button
                  class="button btn autocomplete-clear btn-secondary"
                  @click.prevent="clearFilters">
                  Wyczyść
                </button>
              </d-input-group>
            </div>
          </d-card-header>
          <d-card-body class="p-0 pb-2">
            <table class="table mb-0 responsive-table">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0 id-cell align-middle">Imię i nazwisko</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center">Numer kontaktowy</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center">E-mail</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center">Nazwa sądu</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center">Nazwa kancelarii komorniczej</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center">Sprawy</th>
                  <th scope="col" class="border-0 id-cell align-middle text-center" style="width: 160px">Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(bailiff, index) in bailiffs"
                  :key="bailiff.id">
                  <td>
                    <dt>Imię i nazwisko</dt>
                    <dd>{{ bailiff.name }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>Numer kontaktowy</dt>
                    <dd>{{ bailiff.phone_number }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>E-mail</dt>
                    <dd>{{ bailiff.email }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>Nazwa sądu</dt>
                    <dd>{{ bailiff.court_name }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>Nazwa kancelarii komorniczej</dt>
                    <dd>{{ bailiff.bailiff_office_name }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>Sprawy</dt>
                    <dd>
                      <small class="wsnw"><strong>Zweryfikowane:</strong></small><br>
                      <span
                        :class="{ 'text-success': bailiff.cases_number - bailiff.open_cases_number === bailiff.cases_number}">
                        {{ bailiff.cases_number - bailiff.open_cases_number }}/{{ bailiff.cases_number }}
                      </span>
                    </dd>
                    <dd> </dd>
                  </td>
                  <td class="text-center">
                    <dt>Akcja</dt>
                    <dd>
                      <d-button
                        @click.prevent="editBailiff(bailiff)"
                        class="mx-1 my-1"
                        :disabled="actionInProgress">
                        <i class="material-icons">edit</i> Edytuj
                      </d-button>
                      <d-button
                        theme="danger"
                        class="mx-1 my-1"
                        :disabled="actionInProgress"
                        @click.prevent="removeBailiff(bailiff)">
                        <i class="material-icons">delete</i> Usuń
                      </d-button>
                    </dd>
                  </td>
                </tr>
                <tr v-if="bailiffs.length === 0">
                  <td colspan="7" class="text-center text-info">
                    Brak komorników do wyświetlenia&hellip;
                  </td>
                </tr>
              </tbody>
            </table>
          </d-card-body>
          <d-card-footer>
            <ss-pagination
              :meta-data="paginationMetaData"
              :initial-page="currentPage" />
          </d-card-footer>
        </d-card>
      </transition>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import SsPagination from '@/components/common/SsPaginationNew';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';

export default {
  name: 'BailiffsList',
  mixins: [HasFilters, HasPagination],
  components: {
    SsPagination
  },
  data () {
    return {
      actionInProgress: false,
      bailiffs: [],
      filters: {
        with_cases: ''
      },
      loaded: false,
      loadError: false
    }
  },
  mounted () {
    this.loadItemsData();
  },
  methods: {
    loadItemsData () {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/bailiff/get-bailiffs',
        listField: 'bailiffs',
        pagination: true,
        params: {
          page: this.currentPage,
          where: this.filters
        }
      });
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 500),
    clearFilters () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);

      this.filters = {
        with_cases: ''
      };

      this.$bus.$emit('view-filters-reset');
      this.$bus.$emit('pagination-reset');
    },
    filterList () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.$bus.$emit('pagination-reset');
      this.$bus.$emit('view-filters-save');
    },
    editBailiff (bailiff) {
      this.$router.push({name: 'bailiff-edit', params: {id: bailiff.id}})
    },
    removeBailiff (bailiff) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/bailiff/remove-bailiff/' + bailiff.id,
        id: null,
        successTitle: 'Komornik został usunięty',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie komornika<br /><strong>' + bailiff.name + '</strong>?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie komornika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.actionInProgress = false;
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    }
  }
}
</script>

